import axiosInstance from "@/common/axiosInstance";
import { getFilename } from "@/utils/letter";

const downloadFile = async (id: string | null) => {
  const URL = `/FileDownload/FileDownload?fileId=${id}`;

    try {
      axiosInstance({
        url: URL,
        method: "GET",
        responseType: "blob",
      }).then((response: any) => {
        const contentDisposition = response.headers["content-disposition"];
        let filename = "downloaded-file";
        if (contentDisposition) {
          filename = getFilename(contentDisposition);
        }
  
        const href = window.URL.createObjectURL(response.data);
  
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
  
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
      });
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    };
    return obj;
  }
};

const downloadNominationTNCFile = async (id: string) => {
  const URL = `/Nominations/DownloadNominationTNCFile/${id}`;

    try {
      axiosInstance({
        url: URL,
        method: "GET",
        responseType: "blob",
      }).then((response: any) => {
        const contentDisposition = response.headers["content-disposition"];
        let filename = "downloaded-file";
        if (contentDisposition) {
          filename = getFilename(contentDisposition);
        }
  
        const href = window.URL.createObjectURL(response.data);
  
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
  
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
      });
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    };
    return obj;
  }
};

const downloadFileZip = async (id: string, uploadType: number) => {
  const URL = `/FileDownload/DownloadAndZip?folderId=${id}&uploadType=${uploadType}`;

    try {
      axiosInstance({
        url: URL,
        method: "GET",
        responseType: "blob",
      }).then((response: any) => {
        const contentDisposition = response.headers["content-disposition"];
        let filename = "downloaded-file";
        if (contentDisposition) {
          filename = getFilename(contentDisposition);
        }
  
        const href = window.URL.createObjectURL(response.data);
  
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
  
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
      });
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    };
    return obj;
  }
};

export { downloadFile, downloadNominationTNCFile, downloadFileZip };
